// extracted by mini-css-extract-plugin
export default {"arrow":"Registration_arrow__KYRpv","h1":"Registration_h1__xQ4l3"};